import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useContext,
} from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import {
  FolderOpenOutlined,
  TeamOutlined,
  ShopOutlined,
  TagsOutlined,
  WhatsAppOutlined,
  UserOutlined,
  LogoutOutlined,
  FundOutlined,
  HomeOutlined,
  ContainerOutlined,
  GoldOutlined,
  ProductOutlined,
  SolutionOutlined,
  BlockOutlined,
  TruckOutlined,
  PlusOutlined,
  SettingOutlined,
  PlayCircleOutlined,
  LineOutlined,
  KeyOutlined,
} from "@ant-design/icons";
import {
  ConfigProvider,
  Flex,
  Dropdown,
  Space,
  Breadcrumb,
  Layout,
  Menu,
  theme,
  Form,
  message,
  notification,
  Button,
} from "antd";
import { ModalForm, ProForm, ProFormText } from "@ant-design/pro-components";
import EN from "antd/locale/en_US";
import "../src/styles/pagesStyles/app.css";
import { PERMISSION } from "./constants/permission.constant.js";
import NotAuthorizedPage from "./pages/NotAuthroized.pages.jsx";
import Clock from "react-live-clock";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "./redux/slices/authSlice.js";
import { changePassword } from "./service/api.service.js";


const { Header, Content, Footer, Sider } = Layout;

// Items for menu of the side bar
// -- START
const getItem = (label, key, icon, to, children = null, permission = null) => {
  return {
    key,
    icon,
    to,
    label: to ? <Link to={to}>{label}</Link> : label,
    children,
    permission,
  };
};

const items = [
  getItem("Home", "/", <HomeOutlined />, "/"),
  getItem(
    "Dashboard",
    "/dashboard",
    <FundOutlined />,
    "/dashboard",
    null,
    "DASHBOARD"
  ),
  getItem(
    "Transactions",
    "/transaction",
    <FolderOpenOutlined />,
    "/transaction",
    null,
    "TRANSACTION_LIST"
  ),

  getItem(
    "Promotions",
    "/promotion",
    <TagsOutlined />,
    "/promotion",
    null,
    "PROMOTION_LIST"
  ),

  getItem(
    "WhatsApp Groups",
    "/whatsappGroup",
    <WhatsAppOutlined />,
    "/whatsappGroup",
    null,
    "WHATSAPP_GROUP_LIST"
  ),
  getItem(
    "Order Clearance",
    "/orderClearance",
    <ContainerOutlined />,
    "/orderClearance",
    null,
    "ORDER_CLEARANCE_LIST"
  ),
  getItem("Gold Bars", "sub1", <GoldOutlined />, null, [
    getItem(
      "Gold Bar Transactions",
      "/goldBarTransaction",
      <FolderOpenOutlined />,
      "/goldBarTransaction",
      null,
      "GOLD_BAR_TRANSACTION_LIST"
    ),
    getItem(
      "Gold Bar Transactions Report",
      "/goldBarTransactionReport",
      <SolutionOutlined />,
      "/goldBarTransactionReport",
      null,
      "GOLD_BAR_TRANSACTION_REPORT_LIST"
    ),
    getItem(
      "Gold Bar Products",
      "/goldBarProducts",
      <ProductOutlined />,
      "/goldBarProducts",
      null,
      "GOLD_BAR_PRODUCT_LIST"
    ),
    getItem(
      "Gold Bar WhatsApp Groups",
      "/goldBarWhatsappGroup",
      <WhatsAppOutlined />,
      "/goldBarWhatsappGroup",
      null,
      "GOLD_BAR_WHATSAPP_GROUP_LIST"
    ),
  ]),
  getItem(
    "O/B Transaction",
    "/obTransaction",
    <FolderOpenOutlined />,
    "/obTransaction",
    null,
    "OB_TRANSACTION_LIST"
  ),
  getItem("Order Management", "sub2", <TruckOutlined />, null, [
    getItem(
      "Delivery Order List",
      "/deliveryOrder",
      <TruckOutlined />,
      "/deliveryOrder",
      null,
      "DELIVERY_ORDER_LIST"
    ),
    getItem(
      "Customer List",
      "/customerList",
      <PlusOutlined />,
      "/customerList",
      null,
      "CUSTOMER_LISTS"
    ),
  ]),
  getItem(
    "Marketing Campaign",
    "/marketingCampaign",
    <BlockOutlined />,
    "/marketingCampaign",
    null,
    "MARKETING_CAMPAIGN_LIST"
  ),
  getItem(
    "Gold Trade In",
    "/goldTradeIn",
    <GoldOutlined />,
    "/goldTradeIn",
    null,
    "GOLD_TRADE_IN_LIST"
  ),
  getItem(
    "Platform Product",
    "/platformProduct",
    <ProductOutlined />,
    "/platformProduct",
    null,
    "PLATFORM_PRODUCT_LISTS"
  ),
  getItem("FB Live", "sub4", <PlayCircleOutlined />, null, [
    getItem(
      "FB Live List",
      "/fbLiveList",
      <LineOutlined />,
      "/fbLiveList",
      null,
      "FB_LIVE_LIST"
    ),
    getItem(
      "FB Live Order",
      "/fbLiveOrder",
      <FolderOpenOutlined />,
      "/fbLiveOrder",
      null,
      "FB_LIVE_ORDER_LIST"
    ),
    getItem(
      "FB Live Order Approval",
      "/fbLiveOrderApproval",
      <FolderOpenOutlined />,
      "/fbLiveOrderApproval?1&statuses[]=2",
      null,
      "FB_LIVE_ORDER_APPROVAL_LIST"
    ),
  ]),
  getItem("Administrator", "sub3", <SettingOutlined />, null, [
    getItem("Users", "/users", <TeamOutlined />, "/users", null, "USER_LIST"),
    getItem("Roles", "/roles", <UserOutlined />, "/roles", null, "ROLE_LIST"),
    getItem(
      "Branch",
      "/branch",
      <ShopOutlined />,
      "/branch",
      null,
      "BRANCH_LIST"
    ),
    getItem(
      "GPS",
      "/GPS",
      <SettingOutlined />,
      "/GPS",
      null,
      "UPDATE_GOLD_PRICE_SETTING"
    ),
  ]),
];
// -- END

const App = () => {
  message.useMessage();

  const location = useLocation();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const {
    token: { borderRadiusLG },
  } = theme.useToken();

  const [selectedKey, setSelectedKey] = useState(location.pathname);
  const [breadCrumb, setBreadCrumb] = useState("Home");
  const [newItems, setNewItems] = useState([]);
  // 🌙 Dark mode toggle state
  const [isDark, setIsDark] = useState(
    () => localStorage.getItem("theme") === "dark"
  );
  const [bgColor, setBgColor] = useState("rgb(255, 255, 255)");

  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [changePasswordForm] = Form.useForm();

  const [api, contextHolder] = notification.useNotification();
  // const { openNotification } = useContext(NotificationContext);

  // Wrap notification function
  // const openNotification = useCallback(
  //   (title, description) => {
  //     api.open({
  //       message: title,
  //       description,
  //       placement: "topRight",
  //       showProgress: true,
  //       pauseOnHover: true,
  //     });
  //   },
  //   [api]
  // );

  // const [api, contextHolder] = notification.useNotification();

  // const openNotification = useCallback((title, message) => () => {
  //   api.open({
  //     message: title,
  //     description: message,
  //     showProgress: true,
  //     pauseOnHover: true,
  //   });
  // }, [api])

  // const [api, contextHolder] = notification.useNotification();

  // const openNotification = useCallback((title, description) => {
  //   notification.open({
  //     message: title,
  //     description,
  //     placement: "topRight",
  //     showProgress: true,
  //     pauseOnHover: true,
  //   });
  // }, []);

  const checkMenuFunc = useCallback(() => {
    const hasPermission = (perm) =>
      !perm || auth.permissions.includes(PERMISSION[perm]);

    const filterMenu = (menu) => {
      return menu
        .map((item) => {
          // If item has children, filter them recursively
          if (Array.isArray(item.children) && item.children.length > 0) {
            let filteredChildren = filterMenu(item.children);
            if (filteredChildren.length > 0) {
              if (auth.userId !== 1 && auth.userId !== 30 && auth.userId !== 59) {
                filteredChildren = filteredChildren.filter(
                  (fc) => fc.key !== "/GPS"
                );
              }

              return { ...item, children: filteredChildren };
            }
            return null; // no permitted children, remove this item
          }

          // Leaf menu item: check permission
          return hasPermission(item.permission) ? item : null;
        })
        .filter(Boolean);
    };

    let filteredItems = filterMenu(items);

    setNewItems(filteredItems);

    // Recursive search that also tracks parent
    const findItemWithParent = (items, key, parent = null) => {
      const tmpPathName = key.split("/");
      let tmpSelectedKey = "/";

      if (tmpPathName.length > 1) {
        tmpSelectedKey = tmpPathName[1] ? `/${tmpPathName[1]}` : "/";
      }

      for (const item of items) {
        if (item.key === tmpSelectedKey) {
          return { item, parent, pathNameArr: tmpPathName };
        }
        if (item.children?.length) {
          const found = findItemWithParent(item.children, key, item);
          if (found) return found;
        }
      }
      return null;
    };

    const result = findItemWithParent(items, location.pathname);

    const breadcrumbParts = ["Home"];

    if (result) {
      const { item, parent, pathNameArr } = result;

      if (parent) {
        breadcrumbParts.push(
          typeof parent.label === "string"
            ? parent.label
            : parent.label?.props?.children ?? ""
        );
      }

      breadcrumbParts.push(
        typeof item.label === "string"
          ? item.label
          : item.label?.props?.children ?? ""
      );

      if (pathNameArr.length > 2) {
        // for (let x = 1; x < pathNameArr.length; x++) {
        breadcrumbParts.push(pathNameArr[pathNameArr.length - 1]);
        // }
      }
    }

    setBreadCrumb(breadcrumbParts.join(" / "));
  }, [auth.permissions, auth.userId, location.pathname]);

  // Function to submit change password
  const submitUpdateChangePassword = useCallback(
    async (postData) => {
      try {
        if (!postData || typeof postData !== "object") {
          message.error("Invalid o/b transaction data");
          return;
        }

        const formattedData = {
          current_password: postData.currentPassword,
          new_password: postData.newPassword,
          confirm_password: postData.confirmPassword,
        };

        const result = await changePassword(formattedData);

        if (!result?.status) {
          message.error(result?.message || "Failed to change password");
          return;
        }

        message.success(result.message);
        changePasswordForm.resetFields();
        setOpenChangePasswordModal(false);
      } catch (error) {
        console.error("Error change password:", error);
        message.error(
          error.message || "An error occurred while change password"
        );
      }
    },
    [changePasswordForm]
  );

  /* Use effect section */
  useEffect(() => {
    if (isDark) {
      setBgColor("rgb(30, 30, 30)");
      document.documentElement.classList.add("darkMode");
    } else {
      setBgColor("rgb(255, 255, 255)");
      document.documentElement.classList.remove("darkMode");
    }

    // const modifiedBreadCrumb = [
    //   "Home",
    //   ...location.pathname
    //     .split("/")
    //     .filter(Boolean)
    //     .map(
    //       (segment) => `${segment.charAt(0).toUpperCase()}${segment.slice(1)}`
    //     ),
    // ].join(" / ");
    // setBreadCrumb(modifiedBreadCrumb);

    // set selected key
    const tmpPathName = location.pathname.split("/");
    let tmpSelectedKey = "/";

    if (tmpPathName.length > 1) {
      tmpSelectedKey = tmpPathName[1] ? `/${tmpPathName[1]}` : "/";
    }

    setSelectedKey(tmpSelectedKey);
    checkMenuFunc();
  }, [location, auth.userId, auth.permissions, checkMenuFunc, isDark]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // const socket = getSocket();
    // return () => {
    // socket.off("pong");
    // };
    // const available_notification_pages = ["/fbLiveOrder", "/fbLiveOrderApproval"];
    // try {
    //   const socket = createSocket();
    //   // On connect
    //   socket.on("connect", () => {
    //     console.log("✅ Connected:", socket.id);
    //     // Example: send a ping
    //     socket.emit("ping");
    //   });
    //   // Listen for events
    //   socket.on("pong", (msg) => {
    //     console.log("📩 Pong:", msg);
    //   });
    //   socket.on("orderCreated", (data) => {
    //     const title = "📦 New order";
    //     console.log("New ORDER");
    //     if (available_notification_pages.includes(location.pathname)) {
    //       openNotification(title, data);
    //     }
    //   });
    //   // ✅ Cleanup: disconnect when unmounting
    //   return () => {
    //     socket.disconnect();
    //     socket.off("connect");
    //     socket.off("orderCreated");
    //     socket.off("connect_error");
    //   };
    // } catch (error) {
    //   console.log(error.message);
    // }
  }, []);
  /* Use effect section */

  // Function to handle logout icon onclick
  const handleLogOutIconOnClick = () => {
    dispatch(logoutUser());
  };

  const dropdownItems = [
    {
      key: "1",
      icon: <KeyOutlined />,
      label: "Change Password",
      onClick: () => {
        setOpenChangePasswordModal(true);
      },
    },
    {
      type: "divider",
    },
    {
      key: "2",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: () => {
        handleLogOutIconOnClick();
      },
    },
  ];

  // 🌙 Toggle theme handler
  const toggleTheme = () => {
    setIsDark((prev) => {
      const newTheme = !prev;
      localStorage.setItem("theme", newTheme ? "dark" : "light");
      return newTheme;
    });

    document.documentElement.classList.toggle("darkMode");
  };

  // Function to handle the closing of the modal
  const handleModalOnOpenChange = (visible) => {
    setOpenChangePasswordModal(visible);
  };

  // form content
  const changePasswordFormContent = useMemo(
    () => (
      <div>
        <ProForm.Group>
          <ProFormText.Password
            name="currentPassword"
            label="Current Password"
            width={"xl"}
            placeholder="Enter your current password"
            rules={[
              { required: true, message: "Current Password is required" },
            ]}
          />
          <ProFormText.Password
            name="newPassword"
            label="New Password"
            width={"xl"}
            placeholder="Enter your new password"
            rules={[{ required: true, message: "New Password is required" }]}
          />
        </ProForm.Group>
        <ProForm.Group>
          <ProFormText.Password
            name="confirmPassword"
            label="Confirm Password"
            width={"xl"}
            placeholder="Enter your confirm password"
            rules={[
              { required: true, message: "Confirm Password is required" },
            ]}
          />
        </ProForm.Group>
      </div>
    ),
    []
  );

  const ChangePasswordForm = useMemo(() => {
    return (
      <ModalForm
        title={"Change Password"}
        open={openChangePasswordModal}
        form={changePasswordForm}
        onFinish={submitUpdateChangePassword}
        onOpenChange={handleModalOnOpenChange}
        // className="popup-form"
        modalProps={{
          okText: "Save",
          cancelText: "Cancel",
        }}
        // submitter={{
        //   submitButtonProps:
        //     isCreateMode || isUpdateMode
        //       ? {
        //         disabled: isImageUploading,
        //       }
        //       : isDeleteDisabled || !permissionToDelete
        //         ? {
        //           style: { display: "none" },
        //         }
        //         : {
        //           danger: isViewMode,
        //         },
        // }}
        width={575}
      >
        {changePasswordFormContent}
      </ModalForm>
    );
  }, [
    changePasswordForm,
    changePasswordFormContent,
    openChangePasswordModal,
    submitUpdateChangePassword,
  ]);

  return (
    <ConfigProvider
      locale={EN}
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <Layout
        style={{ minHeight: "100vh" }}
        id="maindiv"
        className={isDark ? "darkMode" : ""}
      >
        {/* Side Bar */}
        <Sider
          collapsedWidth={50}
          width={225}
          breakpoint="lg"
          collapsible={!isMobile}
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
        >
          <div className="side-bar-logo-container">
            <img src="/chgd-logo-white.png" alt="Logo" className="logo" />
          </div>

          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[selectedKey]}
            items={newItems}
          />
        </Sider>

        {/* Main Layout */}
        <Layout
          style={{
            background: isDark ? "rgb(26 26 26)" : null,
          }}
        >
          <Header
            style={{
              paddingInline: "2rem",
              backgroundColor: bgColor,
              boxShadow: "0px 3px 5px rgb(255 255 255 / 7%)",
            }}
          >
            <div className="app-header-content-container">
              {/* {auth.permissions.includes(
                PERMISSION.UPDATE_DO_DELIVERY_STATUS
              ) ? (
                <Button
                  type="primary"
                  className="qrscanBtn"
                  onClick={() => updateModalOnOpen()}
                >
                  <CameraOutlined></CameraOutlined>
                  Scan
                </Button>
              ) : (
                <></>
              )} */}
              <Flex style={{ alignItems: "center" }}>
                {/* 🌙 Theme Toggle Button */}
                {/* <Button onClick={toggleTheme} style={{ marginInline: 6 }}>
                  {isDark ? "🌞 Light Mode" : "🌙 Dark Mode"}
                </Button> */}
                <label class="ui-switch">
                  <input
                    type="checkbox"
                    value={isDark}
                    onChange={toggleTheme}
                  />
                  <div class="slider">
                    <div class="circle"></div>
                  </div>
                </label>
                <Clock
                  format={"hh:mm:ss A"}
                  ticking={true}
                  timezone={"Asia/Kuala_Lumpur"}
                  style={{ fontWeight: "bold" }}
                />
                <div>
                  <Dropdown menu={{ items: dropdownItems }} trigger={["click"]}>
                    <Link onClick={(e) => e.preventDefault()}>
                      <Space>
                        <UserOutlined style={{ paddingLeft: 10 }} />
                        {auth.username || "Guest"}
                      </Space>
                    </Link>
                  </Dropdown>

                  {/* <LogoutOutlined
                    style={{ paddingInline: 10 }}
                    onClick={handleLogOutIconOnClick}
                  /> */}
                </div>
              </Flex>
            </div>
          </Header>
          <Content className="app-content">
            {/* Breadcrumb */}
            <Breadcrumb
              style={{
                margin: "1rem",
              }}
              items={[{ title: breadCrumb }]}
            />

            {/* Routes */}
            <div
              style={{
                background: bgColor,
                borderRadius: borderRadiusLG,
              }}
              className="app-page-content-container"
            >
              <Routes>
                <Route path="/*" element={<NotAuthorizedPage />} />
              </Routes>
            </div>
            {/* {ScanForUpdateDeliveryStatusModal} */}
          </Content>

          {/* Footer */}
          <Footer
            style={{
              textAlign: "center",
              backgroundColor: bgColor,
              boxShadow: "0px -2px 5px rgb(255 255 255 / 7%)",
            }}
          >
            CH All Rights Reserved
          </Footer>
        </Layout>
      </Layout>

      {ChangePasswordForm}
      {/* Notification */}
      {/* {contextHolder}  */}
    </ConfigProvider>
  );
};

export default App;
